import { Paper, Slide } from '@mui/material'
import React from 'react'

import { useChatContext } from './ChatContext'
import { ChatHeader } from './ChatHeader'
import { ChatInput } from './ChatInput'
import { ChatMessageList } from './ChatMessageList'
import { ChatQuickActions } from './ChatQuickActions'
import { useChat } from './useChat'

export const ChatPanel = () => {
    const { isOpen } = useChatContext()
    const { messages, sendMessage, isLoading } = useChat()

    const handleSend = (text: string) => {
        void sendMessage(text)
    }

    return (
        <Slide direction="left" in={isOpen} mountOnEnter unmountOnExit>
            <Paper
                elevation={8}
                sx={{
                    position: 'fixed',
                    top: 72,
                    right: 0,
                    bottom: 0,
                    width: 420,
                    borderRadius: 0,
                    borderLeft: '1px solid rgba(175, 175, 175, 1)',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    zIndex: 1000,
                    boxShadow: '-4px 0 16px rgba(8, 41, 78, 0.08)',
                }}
                data-test="chat-panel"
            >
                <ChatHeader />

                <ChatMessageList messages={messages} isLoading={isLoading} />

                {messages.length <= 1 && <ChatQuickActions onSelect={handleSend} />}

                <ChatInput onSend={handleSend} disabled={isLoading} />
            </Paper>
        </Slide>
    )
}
